import { Row,Divider } from "antd";
import { useDispatch } from "react-redux";
import { useEffect, useState } from "react";

import get from "lodash/get";
import round from "lodash/round";
import slice from "lodash/slice";
import sortBy from "lodash/sortBy";

import GraphGrid from "../graphGrid";
import GraphHeader from "./graphHeader";


import { getTransformedMinutes } from "../../../utilities/helpers";
import { fetchScopeNodeHierarchy } from "../../../redux/actions/locationActions";

const InjectionMouldingGraphSection = ({
  selectedTemplate,
  onChangeParams,
  filter,
  setLoading,
}) => {
  const data = get(selectedTemplate, "graph_report");
  const dispatch = useDispatch();
  const locationId = get(selectedTemplate, "template.location_id");
  const [address, setAddress] = useState();

  const getLocation = (locationId) => {
    setLoading(true);
    dispatch(fetchScopeNodeHierarchy("LOCATION", locationId))
      .then((result) => {
        setAddress(get(result, "name"));
        setLoading(false);
      })
      .catch(() => {
        setLoading(false);
      });
  };

  useEffect(() => {
    if (locationId) {
      getLocation(locationId);
    }
  }, [locationId]);

  return (
    <>
      <GraphHeader
        filter={filter}
        setLoading={setLoading}
        selectedTemplate={selectedTemplate}
        onChangeParams={onChangeParams}
      />

      <Row id="content-container">
        <GraphGrid
          type="time"
          graphId={1}
          stats={get(data, "on_off_graph", [])}
          label={"On / Off / Idle"}
          selectedTemplate={selectedTemplate}
          filter={filter}
          statistics={[
            {
              value: getTransformedMinutes(
                get(selectedTemplate, "meta.total_device_outage_time")
                  ? round(get(selectedTemplate, "meta.total_device_outage_time"))
                  : 0,
              ),
              label: "Power Outage",
            },
            {
              value: getTransformedMinutes(
                get(selectedTemplate, "meta.total_off_hours")
                  ? round(get(selectedTemplate, "meta.total_off_hours"))
                  : 0,
              ),
              label: "Off Hours",
            },
            {
              value: getTransformedMinutes(
                get(selectedTemplate, "meta.total_idle_hours")
                  ? round(get(selectedTemplate, "meta.total_idle_hours"))
                  : 0,
              ),
              label: "Idle  Hours",
            },
            {
              value: getTransformedMinutes(
                get(selectedTemplate, "meta.total_working_hours")
                  ? round(get(selectedTemplate, "meta.total_working_hours"))
                  : 0,
              ),
              label: "Working Hours",
            },
          ]}
        />
        <Divider />
        <GraphGrid
          graphId={2}
          type="time"
          label={"Shots"}
          stats={sortBy(slice(get(data, "count_graph", [])), "date")}
          statistics={[
            {
              value: get(selectedTemplate, "meta.total_shots")
                ? round(get(selectedTemplate, "meta.total_shots"))
                : 0,
              label: "Shots",
            },
          ]}
          selectedTemplate={selectedTemplate}
          filter={filter}
        />
        <Divider />
        <GraphGrid
          graphId={3}
          type="time"
          label={"Open Time"}
          stats={get(data, "open_time_graph", [])}
          statistics={[
            {
              value: `${get(selectedTemplate, "meta.avg_open_time") ? round(get(selectedTemplate, "meta.avg_open_time")) : 0} Sec`,
              label: "Avg. Open Hours",
            },
          ]}
          selectedTemplate={selectedTemplate}
          filter={filter}
        />
        <Divider />
        <GraphGrid
          graphId={4}
          type="time"
          label={"Close Time"}
          stats={get(data, "close_time_graph", [])}
          meta={{
            cycle_time: get(
              selectedTemplate,
              "meta.calculated_stats.cycle_time",
            ),
          }}
          statistics={[
            {
              value: `${get(selectedTemplate, "meta.avg_close_time") ? round(get(selectedTemplate, "meta.avg_close_time")) : 0} Sec`,
              label: "Avg. Close Hours",
            },
          ]}
          selectedTemplate={selectedTemplate}
          filter={filter}
        />
        <Divider />
        {get(data, "power_consumption_graph") && (
          <GraphGrid
            type="time"
            graphId={5}
            label={"Power Consumption"}
            stats={get(data, "power_consumption_graph", [])}
            statistics={[
              {
                value: `${
                  get(selectedTemplate, "meta.total_power_consumption")
                    ? round(
                        get(selectedTemplate, "meta.total_power_consumption"),
                      )
                    : 0
                } Kwh`,
                label: "Power Consumption",
              },
            ]}
            selectedTemplate={selectedTemplate}
            filter={filter}
          />
        )}
      </Row>
    </>
  );
};

export default InjectionMouldingGraphSection;
